module.exports = __webpack_public_path__ + "img/tiger-machine-panel.3ab6df95.svg";